// Отчёты группируются по моменту снимка — по тому, «когда была та ситуация»,
// а не когда пользователь нажал «Сохранить».
export const REPORT_GROUP_ORDER = ['today', 'yesterday', 'thisWeek', 'earlier']

const DAY_MS = 24 * 60 * 60 * 1000

export function reportTimestamp(report) {
  return report?.captured_at || report?.created_at || null
}

function startOfDay(date) {
  const copy = new Date(date)
  copy.setHours(0, 0, 0, 0)
  return copy.getTime()
}

// Неделя здесь скользящая: календарная сделала бы вчерашний отчёт
// «прошлой неделей» каждый понедельник.
export function reportGroupKey(value, now = new Date()) {
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return 'earlier'
  const days = Math.round((startOfDay(now) - startOfDay(date)) / DAY_MS)
  if (days <= 0) return 'today'
  if (days === 1) return 'yesterday'
  if (days < 7) return 'thisWeek'
  return 'earlier'
}

export function groupReports(reports, now = new Date()) {
  const buckets = new Map(REPORT_GROUP_ORDER.map((key) => [key, []]))
  for (const report of reports || []) {
    buckets.get(reportGroupKey(reportTimestamp(report), now)).push(report)
  }
  return REPORT_GROUP_ORDER
    .map((key) => ({ key, items: buckets.get(key) }))
    .filter((group) => group.items.length > 0)
}

export function formatReportTimestamp(value, language = 'ru') {
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return ''
  return new Intl.DateTimeFormat(language === 'kk' ? 'kk-KZ' : 'ru-RU', {
    day: '2-digit',
    month: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  }).format(date)
}
